import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

function NotFound() {
  const { t } = useLanguage();
  return (
    <section className="section section--notfound">
      <div className="notfound-overlay" />
      <div className="notfound-content">
        <p className="notfound-kicker">{t('notfound.kicker')}</p>
        <h1 className="notfound-title">{t('notfound.title')}</h1>
        <p className="notfound-subtitle">
          {t('notfound.subtitle')}
        </p>
        <div className="notfound-actions">
          <Link to="/" className="notfound-btn notfound-btn--primary">
            {t('notfound.home')}
          </Link>
          <Link to="/locales" className="notfound-btn notfound-btn--ghost">
            {t('notfound.locales')}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
